// extracted by mini-css-extract-plugin
export default {"language":"SelectLanguage_language__+SbwC","language__list":"SelectLanguage_language__list__o4jrv","language__list_item":"SelectLanguage_language__list_item__6CxZV"};